import { render, staticRenderFns } from "./ContactFormDiagnostic.vue?vue&type=template&id=6b890539&"
import script from "./ContactFormDiagnostic.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ContactFormDiagnostic.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports